module.exports = __webpack_public_path__ + "files/6d6c96e430cb8d56259134f7f3bb8da8.png";